// extracted by extract-css-chunks-webpack-plugin
module.exports = {"limit-count":"_1lo-ZC","limit-count-warning":"_357Yvo"};